module.exports = __webpack_public_path__ + "img/undraw_polaroid_gg6n.0aaa9bb2.svg";